// Angular modules
import { DatePipe }      from '@angular/common';
import { Pipe }          from '@angular/core';
import { PipeTransform } from '@angular/core';

// External modules
import * as moment       from 'moment-timezone';

// Services
import { AuthService }   from '../services/auth.service';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe extends DatePipe implements PipeTransform
{
  private businessProfile = JSON.parse(localStorage.getItem(AuthService.BusinessProfileKey));

  transform(value: any, format?: string, args?: any): any {
    if (!value) {
      return '';
    }

    let timezone = null;
    if (this.businessProfile && this.businessProfile.timezoneDetails) {
      timezone = this.businessProfile.timezoneDetails.name;
    } else {
      console.log('no timezone info available in the business profile');
    }

    if (timezone !== null && !format) {
      return moment(value).tz(timezone).format('yyyy-MM-DD HH:mm:ss');
    } else if (timezone !== null && format) {
      return moment(value).tz(timezone).format(format);
    } else {
      return super.transform(value, 'yyyy-MM-dd HH:mm:ss');
    }
  }
}
